define(["require", "exports", "tslib", "clipboard", "vue"], function (require, exports, tslib_1, clipboard_1, vue_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.DirectiveClipboard = void 0;
    clipboard_1 = (0, tslib_1.__importDefault)(clipboard_1);
    vue_1 = (0, tslib_1.__importDefault)(vue_1);
    if (!clipboard_1.default) {
        throw new Error('you should npm install `clipboard` --save at first ');
    }
    var successCallback;
    var errorCallback;
    var clipboardInstance;
    var DirectiveClipboard = (function (_super) {
        (0, tslib_1.__extends)(DirectiveClipboard, _super);
        function DirectiveClipboard() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        DirectiveClipboard.prototype.bind = function (el, binding, vnode) {
            if (binding.arg === 'success') {
                successCallback = binding.value;
            }
            else if (binding.arg === 'error') {
                errorCallback = binding.value;
            }
            else {
                clipboardInstance = new clipboard_1.default(el, {
                    text: function () {
                        return binding.value;
                    },
                    action: function () {
                        return binding.arg === 'cut' ? 'cut' : 'copy';
                    }
                });
                clipboardInstance.on('success', function (e) {
                    var callback = successCallback;
                    if (callback) {
                        callback(e);
                    }
                });
                clipboardInstance.on('error', function (e) {
                    var callback = errorCallback;
                    if (callback) {
                        callback(e);
                    }
                });
            }
        };
        DirectiveClipboard.prototype.update = function (el, binding) {
            if (binding.arg === 'success') {
                successCallback = binding.value;
            }
            else if (binding.arg === 'error') {
                errorCallback = binding.value;
            }
            else {
                clipboardInstance = new clipboard_1.default(el, {
                    text: function () {
                        return binding.value;
                    },
                    action: function () {
                        return binding.arg === 'cut' ? 'cut' : 'copy';
                    }
                });
            }
        };
        DirectiveClipboard.prototype.unbind = function (_, binding) {
            if (binding.arg === 'success') {
                successCallback = null;
            }
            else if (binding.arg === 'error') {
                errorCallback = null;
            }
            else {
                if (clipboardInstance) {
                    clipboardInstance.destroy();
                }
                clipboardInstance = null;
            }
        };
        return DirectiveClipboard;
    }(vue_1.default));
    exports.DirectiveClipboard = DirectiveClipboard;
});
//# sourceMappingURL=DirectiveClipboard.js.map